module.exports = __webpack_public_path__ + "media/images/clippy-white-2730192b.svg";